import React from 'react';
import { FaCheckCircle, FaSearch, FaShieldAlt, FaTag, FaHeadset, FaStar, FaLock, FaUserFriends, FaCalendarAlt, FaHandshake } from 'react-icons/fa';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            <div className="about-page-overlay">
                {/* Hero Section */}
                <section className="about-hero">
                    <div className="about-hero-content">
                        <h1>Welcome to Waghchaure Lawns</h1>
                        <div className="about-hero-underline"></div>
                        <p className="about-hero-tagline">Creating Memorable Events in Exceptional Spaces</p>
                    </div>
                </section>

                {/* Introduction */}
                <section className="about-section">
                    <div className="about-container">
                        <div className="about-intro">
                            <div className="about-intro-content">
                                <h2 className="about-section-title">About Us</h2>
                                <div className="about-section-underline"></div>
                                <p>Founded with a vision to provide exceptional event spaces, Waghchaure Lawns has established itself as a trusted name in event venue bookings. Our journey began with a simple idea: to create beautiful, well-maintained lawns that serve as the perfect backdrop for life's most special moments.</p>
                                <p>Located in picturesque Paithan gaon, Chh.Sambhajinagar, our lawns offer a serene and elegant environment for weddings, corporate events, social gatherings, and more. With years of experience in the hospitality industry, we understand what makes an event truly memorable.</p>
                            </div>
                            <div className="about-image-container">
                                <div className="about-image"></div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Our Services */}
                <section className="about-section about-services-section">
                    <div className="about-container">
                        <h2 className="about-section-title centered-title">Our Services</h2>
                        <div className="about-section-underline centered-underline"></div>

                        <div className="about-services-grid">
                            <div className="about-service-card">
                                <div className="about-service-icon">
                                    <FaSearch />
                                </div>
                                <h3>Venue Selection</h3>
                                <p>Choose from our various lawn options based on your event size and preferences</p>
                            </div>
                            <div className="about-service-card">
                                <div className="about-service-icon">
                                    <FaShieldAlt />
                                </div>
                                <h3>Event Planning</h3>
                                <p>Expert guidance and support for planning your perfect event</p>
                            </div>
                            <div className="about-service-card">
                                <div className="about-service-icon">
                                    <FaTag />
                                </div>
                                <h3>Catering Services</h3>
                                <p>Delicious menu options crafted by experienced chefs</p>
                            </div>
                            <div className="about-service-card">
                                <div className="about-service-icon">
                                    <FaHeadset />
                                </div>
                                <h3>Decoration</h3>
                                <p>Beautiful décor options to enhance your event atmosphere</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Why Choose Us */}
                <section className="about-section about-why-section">
                    <div className="about-container">
                        <h2 className="about-section-title centered-title">Why Choose Us</h2>
                        <div className="about-section-underline centered-underline"></div>

                        <div className="about-why-grid">
                            <div className="about-why-card">
                                <div className="about-why-icon">
                                    <FaStar />
                                </div>
                                <div className="about-why-content">
                                    <h3>Premium Locations</h3>
                                    <p>Strategically located venues with beautiful surroundings</p>
                                </div>
                            </div>
                            <div className="about-why-card">
                                <div className="about-why-icon">
                                    <FaCheckCircle />
                                </div>
                                <div className="about-why-content">
                                    <h3>Experienced Team</h3>
                                    <p>Professional staff with years of event management expertise</p>
                                </div>
                            </div>
                            <div className="about-why-card">
                                <div className="about-why-icon">
                                    <FaLock />
                                </div>
                                <div className="about-why-content">
                                    <h3>Customizable Packages</h3>
                                    <p>Flexible options tailored to your specific requirements</p>
                                </div>
                            </div>
                            <div className="about-why-card">
                                <div className="about-why-icon">
                                    <FaUserFriends />
                                </div>
                                <div className="about-why-content">
                                    <h3>Customer Satisfaction</h3>
                                    <p>Dedicated to exceeding your expectations</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Mission & Vision */}
                <section className="about-section about-mission-vision">
                    <div className="about-container">
                        <div className="about-mission-vision-grid">
                            <div className="about-mission-card">
                                <h2>Our Mission</h2>
                                <div className="about-card-underline"></div>
                                <p>To provide exceptional event spaces and services that create memorable experiences for our clients and their guests, ensuring every celebration becomes a cherished memory.</p>
                            </div>
                            <div className="about-vision-card">
                                <h2>Our Vision</h2>
                                <div className="about-card-underline"></div>
                                <p>To be the premier destination for event venues in Chh.Sambhajinagar, known for our beautiful lawns, outstanding service, and commitment to excellence.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default About;
